export const FLAIR_INFURA_PROJECT_ID = '21891c5f45de4147900a7539f5948dbf';
